import { useMyPaymentById } from "api/Client/balance";
import { Spinner } from "components";
import { image_host } from "config/api_host";
import {
  HiOutlineBanknotes,
  HiOutlineCalendarDays,
  HiOutlineCheckCircle,
  HiOutlineClock,
  HiOutlineHashtag,
  HiOutlineIdentification,
  HiOutlineWallet,
  HiOutlineXCircle,
} from "react-icons/hi2";
import ClientActionModal from "../ClientActionModal/ClientActionModal";

const getStateMeta = (state) => {
  if (state === "pending") {
    return { label: "انتظار", icon: <HiOutlineClock />, color: "text-amber-400" };
  }
  if (state === "approved") {
    return { label: "مكتملة", icon: <HiOutlineCheckCircle />, color: "text-emerald-400" };
  }
  return { label: "مرفوضة", icon: <HiOutlineXCircle />, color: "text-rose-400" };
};

export default function MyPaymentModal({ isOpen, toggle, paymentId }) {
  const {
    data: currentPayment,
    isSuccess: currentPaymentIsSuccess,
    isFetching: currentPaymentIsFetching,
  } = useMyPaymentById(paymentId);

  const openImageInPopup = (url, title, width = 600, height = 400) => {
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
    const newWindow = window.open(
      "",
      title,
      `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
    );

    if (newWindow) {
      newWindow.document.write(`
      <html>
        <head><title>${title}</title></head>
        <body style="margin:0;padding:0;background:#2a1200;display:grid;place-items:center;">
          <img src="${url}" style="width:100%;height:100%;object-fit:contain;" />
        </body>
      </html>
    `);
      newWindow.document.close();
    }
  };

  return (
    <ClientActionModal open={isOpen} close={toggle} size="xSmall" title="تفاصيل الدفعة">
      {currentPaymentIsFetching ? (
        <div className="portal-page-card mx-auto flex items-center justify-center rounded-[1.35rem] p-6">
          <Spinner sm />
        </div>
      ) : (
        currentPaymentIsSuccess && (
          <div className="grid grid-cols-1 gap-3">
            <div className="portal-page-card grid gap-3 rounded-[1.35rem] p-5">
              <div className="flex items-center justify-between gap-3">
                <div
                  className={`flex items-center gap-2 text-sm font-bold ${
                    getStateMeta(currentPayment.data.state_notify).color
                  }`}
                >
                  <span className="text-xl">
                    {getStateMeta(currentPayment.data.state_notify).icon}
                  </span>
                  {getStateMeta(currentPayment.data.state_notify).label}
                </div>
                <h2 className="text-xl font-bold portal-accent" style={{ direction: "ltr" }}>
                  {Number(currentPayment.data.amount).toLocaleString()}{" "}
                  <span className="text-sm">
                    {currentPayment.data.order_type === "bankNotice"
                      ? currentPayment.data.currncy_bank
                      : currentPayment.data.currency_customer}
                  </span>
                </h2>
              </div>

              <InfoRow
                icon={<HiOutlineBanknotes className="text-orange-400" />}
                label="نوع العملية"
                value={
                  currentPayment.data.order_type === "bankNotice"
                    ? "إشعار بنكي"
                    : currentPayment.data.order_type === "balanceRecharge"
                      ? "شحن رصيد"
                      : "- - - -"
                }
              />
              <InfoRow icon={<HiOutlineIdentification className="text-amber-400" />} label="رقم الإشعار" value={currentPayment.data.notify_number} />
              <InfoRow icon={<HiOutlineHashtag className="text-orange-300" />} label="الملاحظات" value={currentPayment.data.notes} />
              <InfoRow icon={<HiOutlineCalendarDays className="text-orange-400" />} label="التاريخ" value={currentPayment.data.created_at} ltr />
              <InfoRow icon={<HiOutlineWallet className="text-emerald-400" />} label="المبلغ المضاف" value={`${Number(currentPayment.data.total_amount).toLocaleString()} ${currentPayment.data.currency_customer}`} ltr />
            </div>

            {currentPayment.data.rejection_reason ? (
              <div className="portal-panel-soft rounded-[1.35rem] p-5">
                <h5 className="mb-4 text-lg font-bold portal-accent">
                  {currentPayment.data.state_notify === "rejected" ? "سبب الرفض" : "الملاحظات"}
                </h5>
                <div
                  className="break-words font-bold leading-7"
                  style={{ color: "var(--layout-text)" }}
                  dangerouslySetInnerHTML={{
                    __html: currentPayment.data?.rejection_reason?.replace(/\n/g, "<br />"),
                  }}
                />
              </div>
            ) : null}

            {currentPayment.data.notify_image ? (
              <div className="portal-panel-soft rounded-[1.35rem] p-5">
                <h5 className="mb-4 text-lg font-bold portal-accent">صورة الإشعار</h5>
                <img
                  onClick={() =>
                    openImageInPopup(
                      `${image_host}${currentPayment.data.notify_image}`,
                      `المركز: ${currentPayment.data.center_name} | رقم الإشعار: ${currentPayment.data.notify_number} |`,
                      800,
                      600
                    )
                  }
                  src={`${image_host}${currentPayment.data.notify_image}`}
                  alt="صورة الإشعار"
                  className="mx-auto max-h-[420px] w-full cursor-pointer rounded-2xl object-contain"
                />
              </div>
            ) : null}
          </div>
        )
      )}
    </ClientActionModal>
  );
}

function InfoRow({ icon, label, value, ltr = false }) {
  return (
    <div className="flex items-start gap-3" style={{ color: "var(--layout-text-muted)" }}>
      <div className="text-xl">{icon}</div>
      <div className="flex min-w-0 flex-col gap-1">
        <span className="text-xs font-semibold portal-accent">{label}</span>
        <span className="font-bold break-all" style={{ direction: ltr ? "ltr" : "rtl", color: "var(--layout-text)" }}>
          {value}
        </span>
      </div>
    </div>
  );
}
